// extracted by mini-css-extract-plugin
export default {"googlefont":"Top_googlefont__9oUIc","button":"Top_button__WURE5"};